import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEO } from '../utils/seo';
export function FormationPage() {
  return <div className="min-h-screen bg-white" data-id="element-438">
      <SEO title="Formation" description="Formations professionnelles en hôtellerie et tourisme - CSF OFPPT, GIAC, ANAPEC, CFA, programmes langues et management à Agadir Souss Massa" keywords="formation hôtellerie Agadir, OFPPT tourisme, formation professionnelle Maroc, CFA Agadir" data-id="element-439" />
      <Navbar data-id="element-440" />

      {/* Hero */}
      <section className="relative bg-arih-blue py-24 md:py-32 overflow-hidden" data-id="element-441">
        <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-442" />
        <div className="container relative mx-auto px-4 md:px-8 text-center" data-id="element-443">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-6" data-id="element-444">
            Formation
          </h1>
          <p className="text-[20px] text-white/85 leading-[32px] max-w-2xl mx-auto" data-id="element-445">
            Formations et Soutien de l'ARIH Agadir Souss Massa
          </p>
        </div>
      </section>

      {/* Content Blocks */}
      <section className="bg-arih-light-bg py-20 px-4 md:px-8" data-id="element-446">
        <div className="container mx-auto max-w-4xl" data-id="element-447">
          <h2 className="text-[32px] md:text-[36px] font-bold text-arih-dark mb-6" data-id="element-448">
            CSF (Contrats Spéciaux de Formation) de l'OFPPT
          </h2>
          <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-449">
            Les Contrats Spéciaux de Formation (CSF) de l'Office de la Formation
            Professionnelle et de la Promotion du Travail (OFPPT) au Maroc
            permettent aux entreprises de combler leurs besoins en compétences
            en formant des candidats aux métiers spécifiques dont elles ont
            besoin. Ces contrats, établis entre l'entreprise, l'OFPPT et le
            candidat, visent à répondre aux besoins des entreprises tout en
            offrant une formation adaptée aux demandeurs d'emploi. Les CSF
            couvrent divers secteurs d'activité et métiers, contribuant ainsi à
            réduire l'écart entre les compétences disponibles sur le marché du
            travail et les besoins des entreprises.
          </p>
        </div>
      </section>

      <section className="bg-white py-20 px-4 md:px-8" data-id="element-450">
        <div className="container mx-auto max-w-4xl" data-id="element-451">
          <h2 className="text-[32px] md:text-[36px] font-bold text-arih-dark mb-6" data-id="element-452">
            GIAC (Groupement Interprofessionnel d'Aide au Conseil)
          </h2>
          <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-453">
            Le Groupement Interprofessionnel d'Aide au Conseil (GIAC), relevant
            de la Fédération Nationale de l'Industrie Hôtelière (FNIH) au Maroc,
            propose des services de conseil et d'accompagnement aux entreprises
            du secteur de l'hôtellerie. Ces services visent à améliorer la
            performance et la compétitivité des établissements hôteliers en
            offrant des prestations dans les domaines de la gestion, du
            marketing, de la qualité et de la formation, adaptées aux besoins
            spécifiques du secteur.
          </p>
        </div>
      </section>

      <section className="bg-arih-light-bg py-20 px-4 md:px-8" data-id="element-454">
        <div className="container mx-auto max-w-4xl" data-id="element-455">
          <h2 className="text-[32px] md:text-[36px] font-bold text-arih-dark mb-6" data-id="element-456">
            ANAPEC (Agence Nationale de Promotion de l'Emploi et des
            Compétences)
          </h2>
          <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-457">
            L'ANAPEC propose plusieurs programmes dans le secteur du tourisme
            pour promouvoir l'emploi et développer les compétences. Ces
            programmes comprennent des formations professionnelles adaptées aux
            besoins du secteur, facilitent l'insertion professionnelle des
            jeunes diplômés, offrent des programmes spécifiques en partenariat
            avec des entreprises du secteur touristique et apportent un soutien
            à l'entrepreneuriat dans le domaine du tourisme.
          </p>
        </div>
      </section>

      <section className="bg-white py-20 px-4 md:px-8" data-id="element-458">
        <div className="container mx-auto max-w-4xl" data-id="element-459">
          <h2 className="text-[32px] md:text-[36px] font-bold text-arih-dark mb-6" data-id="element-460">
            Offres de Formation
          </h2>
          <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-461">
            Les opportunités de formation dans le secteur du tourisme au Maroc
            comprennent des programmes de l'OFPPT proposant des formations en
            alternance spécialisées et des formations de techniciens. Les
            universités offrent également des programmes de licence et de master
            dans ce domaine. En outre, le secteur privé propose des formations
            universitaires et des cursus dans des écoles spécialisées en
            tourisme.
          </p>
        </div>
      </section>

      <section className="bg-arih-light-bg py-20 px-4 md:px-8" data-id="element-462">
        <div className="container mx-auto max-w-4xl space-y-12" data-id="element-463">
          <h2 className="text-[32px] md:text-[36px] font-bold text-arih-blue mb-6" data-id="element-464">
            Les formations offertes par l'ARIH Agadir Souss Massa
          </h2>

          <div data-id="element-465">
            <h3 className="text-[24px] font-bold text-arih-dark mb-4" data-id="element-466">
              Langues et Management
            </h3>
            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-467">
              ARIH Agadir Souss Massa propose des formations combinant
              l'apprentissage des langues et des modules de gestion adaptés aux
              besoins du secteur touristique. Ces formations visent à renforcer
              les compétences linguistiques des professionnels du tourisme tout
              en leur fournissant les outils de gestion nécessaires pour
              améliorer la performance de leur établissement.
            </p>
          </div>

          <div data-id="element-468">
            <h3 className="text-[24px] font-bold text-arih-dark mb-4" data-id="element-469">
              CFA (Centre de Formation par l'Apprentissage)
            </h3>
            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-470">
              En partenariat avec le ministère de la Formation Professionnelle
              et de la Promotion du Travail, l'ARIH Agadir Souss Massa est en
              cours de mise en place d'un CFA. Ce centre offrira des formations
              en alternance permettant aux apprentis d'acquérir des compétences
              pratiques tout en suivant des cours théoriques. Ces formations
              seront spécifiquement conçues pour répondre aux besoins du secteur
              touristique.
            </p>
          </div>

          <div data-id="element-471">
            <h3 className="text-[24px] font-bold text-arih-dark mb-4" data-id="element-472">
              Programme en cours — Écotourisme
            </h3>
            <p className="text-[18px] text-arih-gray leading-[32px]" data-id="element-473">
              L'ARIH Agadir Souss Massa travaille actuellement sur un programme
              de formation destiné aux apprentis dans le domaine de
              l'écotourisme. Ce programme fournira aux participants les
              compétences nécessaires pour travailler dans des établissements
              touristiques axés sur le développement durable et la préservation
              de l'environnement.
            </p>
          </div>
        </div>
      </section>

      <Footer data-id="element-474" />
    </div>;
}